<template>
    <div class="mt-3" role="alert" v-if="date_warning">
        <p style="color: #FA8300;">{{ date_warning }}</p>
    </div>
</template>

<script>
    export default {
        name: 'VueAlertBox',
        props: {
            date_warning: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: 'Note'
            }
        }
    };
</script>
